module.exports = __webpack_public_path__ + "img/desconto_natura.1c6aaf78.jpg";